
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OrderRequestClientSourceType enum
 */
class OrderRequestClientSourceType {
  /**
   * Initialize enum with a given value
   * @param {OrderRequestClientSourceType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OrderRequestClientSourceType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OrderRequestClientSourceType}
   * @param {!OrderRequestClientSourceType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderRequestClientSourceType)) {
      throw new TypeError('Instance of OrderRequestClientSourceType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OrderRequestClientSourceType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OrderRequestClientSourceType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OrderRequestClientSourceType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === OrderRequestClientSourceType.MOBILE_APP.value) {
      return 'MOBILE_APP'
    }
    if (this.value === OrderRequestClientSourceType.WEB_TRADER.value) {
      return 'WEB_TRADER'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OrderRequestClientSourceType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OrderRequestClientSourceType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OrderRequestClientSourceType} Created enum
   */
  static fromObject (other) {
    return new OrderRequestClientSourceType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OrderRequestClientSourceType.UNKNOWN = new OrderRequestClientSourceType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderRequestClientSourceType.MOBILE_APP = new OrderRequestClientSourceType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderRequestClientSourceType.WEB_TRADER = new OrderRequestClientSourceType(0 + 2)

export { OrderRequestClientSourceType };

/**
 * Fast Binary Encoding OrderRequestClientSourceType field model
 */
class FieldModelOrderRequestClientSourceType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOrderRequestClientSourceType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOrderRequestClientSourceType}
   * @param {OrderRequestClientSourceType=} defaults Default value, defaults is new OrderRequestClientSourceType()
   * @returns {!OrderRequestClientSourceType} Result value
   */
  get (defaults = new OrderRequestClientSourceType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OrderRequestClientSourceType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOrderRequestClientSourceType}
   * @param {!OrderRequestClientSourceType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOrderRequestClientSourceType };
